// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import store from './config/store.js'
import './config/axios.js'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/less/im.less'
import './assets/scripts/TJ_websocket.js'
import './assets/scripts/TJ_WXEmoji.js'
import './assets/scripts/TJ_WWEmoji.js'
import './assets/scripts/TJ_IM.js'
import './assets/scripts/TJ_DB.js'
import './assets/scripts/regionTree.js'
import './assets/scripts/jquery-2.1.1.min.js'
import './assets/scripts/jquery.caret.js'
import './assets/scripts/jquery.atwho.js'
import '@/icons'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer)
Viewer.setDefaults({
  'inline':false,//启用 inline 模式
  'button':true, //右上角叉掉按钮
  "navbar": false, //底部缩略图
  "title": true, //当前图片标题
  "toolbar": true, //底部工具栏
  "tooltip": true, //显示缩放百分比
  "movable": true, //是否可以移动
  "zoomable": true, //是否可以缩放
  "rotatable": true, //是否可旋转
  "scalable": true, //是否可翻转
  "transition": true, //使用 CSS3 过度
  "fullscreen": true, //播放时是否全屏
  "keyboard": true, //是否支持键盘
  //"url": "data-source",//坑
  defaultOptions: {
    zIndex: 9999
  },
})

Vue.config.productionTip = false

// 注册ElementUI组件
Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js